export default __webpack_public_path__ + "static/media/sm_polar_bear.75c918bb.gif";